<p
	class="sm:hidden absolute text-xs z-10 font-medium rounded-full top-9 left-8 bg-uc-clearing-103 text-uc-clearing-104 py-0.5 px-2.5"
>
	Available for Clearing {{ currentClearingYear }}
</p>
